import { APIError } from '../core/errors';
import httpClient from '../services/http.service';
import { BASE_URL, DEFAULT_HEADERS} from './api-constants';

//TODO: - write the API calls here
const _api_base_url = `${BASE_URL}/auth/refresh-token`;

interface newTokenResponse {
  access_token: string;

}



// test user fetch.
// TODO: remove later
export const refreshToken = async (parameters:string): Promise<newTokenResponse> => {
  //userEnterMobileNumber=mobileNumber;
  try {
    const response = await httpClient.get(`${_api_base_url}`,{

      headers: {
        ...DEFAULT_HEADERS,
        Authorization: `Bearer ${parameters}`,
      },
    });

    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};


